import React, { useEffect } from "react";
import "./css/TermsAndConditions.css";

import Navbar from "./components/Navbar";
import Newsletter from "./components/NewsLetter";
import Footer from "./components/Footer";

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper">
      {/* Site Navigation Bar */}
      <Navbar />

      {/* Main Content Area */}
      <div className="terms-page">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">

              {/* Page Header */}
              <div className="terms-header text-center mb-5">
                <h1 className="terms-title">Terms & Conditions</h1>
                <p className="terms-subtitle">
                  Fixovera Pvt Ltd
                </p>
              </div>

              {/* Terms Content Card */}
              <div className="terms-card p-4 p-md-5 shadow-sm">

                <p className="lead-text">
                  These Terms & Conditions ("Terms") govern your access to and
                  use of the Fixovera mobile application, website, and related
                  services operated by <strong>Fixovera Pvt Ltd</strong>
                  ("Fixovera", "Company", "we", "us", or "our").
                </p>

                <p>
                  Fixovera operates a household services digital marketplace
                  that connects customers with independent service
                  professionals for household and property-related services,
                  including but not limited to cleaning, plumbing, electrical
                  services, appliance repair, painting, carpentry, pest
                  control, AC and appliance services, home renovation, and
                  other services made available through the Platform.
                </p>

                <p>
                  These Terms apply to all customers, service professionals,
                  partners, and other users accessing or using the Fixovera
                  Platform. By accessing, registering with, or using the
                  Platform, you acknowledge that you have read, understood,
                  and agreed to be legally bound by these Terms, together with
                  Fixovera's Privacy Policy, Refund Policy, and other applicable
                  policies.
                </p>

                <p>
                  If you do not agree with any provision of these Terms, you
                  should not access or use the Platform or any services offered
                  through it.
                </p>

                <hr className="section-divider" />

                <h3>1. Definitions</h3>

                <p>
                  For the purposes of these Terms:
                </p>

                <ul>
                  <li>
                    <strong>"Platform"</strong> means the Fixovera website,
                    mobile application, software, systems, and related digital
                    services.
                  </li>
                  <li>
                    <strong>"Customer"</strong> means any person who uses the
                    Platform to search for, request, schedule, or purchase
                    household services.
                  </li>
                  <li>
                    <strong>"Service Professional"</strong> or
                    <strong> "Service Partner"</strong> means an independent
                    professional or service provider listed or connected
                    through the Platform.
                  </li>
                  <li>
                    <strong>"Booking"</strong> means a service request placed
                    by a Customer through the Platform.
                  </li>
                  <li>
                    <strong>"Services"</strong> means household and related
                    services made available through the Platform.
                  </li>
                  <li>
                    <strong>"User"</strong> means any person accessing or using
                    the Platform, including Customers and Service
                    Professionals.
                  </li>
                </ul>

                <hr className="section-divider" />

                <h3>2. Nature of the Platform</h3>

                <p>
                  Fixovera is a digital marketplace that facilitates
                  connections between Customers and Service Professionals.
                  Unless expressly stated otherwise, Fixovera does not itself
                  perform the household service booked through the Platform.
                </p>

                <p>
                  Service Professionals may be independent third-party
                  providers. Their availability, qualifications, pricing,
                  workmanship, and service performance may vary. Fixovera
                  facilitates discovery, booking, communication, payment
                  processing, tracking, and related marketplace functions.
                </p>

                <p>
                  Customers acknowledge that the actual service may be
                  performed by the assigned Service Professional and that
                  certain service-related matters may be subject to the
                  Service Professional's availability and operational
                  limitations.
                </p>

                <hr className="section-divider" />

                <h3>3. Eligibility and Account Registration</h3>

                <p>
                  You must provide accurate, complete, and current information
                  when creating an account or making a Booking through the
                  Platform.
                </p>

                <p>
                  Users are responsible for maintaining the confidentiality of
                  their account credentials and for all activities performed
                  through their account.
                </p>

                <ul>
                  <li>
                    You must not create an account using false or misleading
                    information.
                  </li>
                  <li>
                    You must not impersonate another person or entity.
                  </li>
                  <li>
                    You must immediately notify Fixovera if you suspect
                    unauthorized access to your account.
                  </li>
                  <li>
                    You must not share your account credentials with another
                    person where such sharing is prohibited by the Platform.
                  </li>
                  <li>
                    Fixovera may suspend or terminate an account where
                    inaccurate information, fraud, misuse, or violation of
                    these Terms is identified.
                  </li>
                </ul>

                <hr className="section-divider" />

                <h3>4. Booking and Service Requests</h3>

                <p>
                  Customers may request services by selecting the relevant
                  service category, service location, preferred date and
                  time, and other information requested by the Platform.
                </p>

                <p>
                  A Booking is considered confirmed only when confirmation is
                  displayed or communicated through the Platform.
                </p>

                <p>
                  Fixovera may contact Customers or Service Professionals in
                  connection with a Booking for confirmation, scheduling,
                  service coordination, safety, customer support, or other
                  operational purposes.
                </p>

                <p>
                  Customers are responsible for providing accurate service
                  addresses, access instructions, contact information, and
                  relevant details about the requested work.
                </p>

                <hr className="section-divider" />

                <h3>5. Pricing and Payments</h3>

                <p>
                  Prices for Services may be displayed on the Platform before
                  confirmation of a Booking. The final amount may depend on
                  the selected service, scope of work, applicable taxes,
                  materials, additional work, location, or other disclosed
                  charges.
                </p>

                <p>
                  Customers agree to pay all amounts applicable to their
                  confirmed Booking using the payment methods supported by
                  Fixovera.
                </p>

                <p>
                  Where additional work is requested beyond the original scope
                  of a Booking, such work may be separately quoted and charged
                  subject to Customer approval.
                </p>

                <p>
                  Fixovera may use third-party payment processors and financial
                  service providers to process payments. Fixovera does not
                  generally store complete payment card information on its own
                  systems where such information is processed by authorized
                  payment providers.
                </p>

                <hr className="section-divider" />

                <h3>6. Cancellation and Refunds</h3>

                <p>
                  Customers may cancel Bookings subject to the cancellation
                  terms applicable to the Booking.
                </p>

                <p>
                  Refund eligibility depends on factors including the timing
                  of cancellation, service completion status, service quality
                  issues, payment errors, and the reason for the refund
                  request.
                </p>

                <p>
                  The detailed refund rules are provided in Fixovera's
                  <strong> Refund Policy — Version 2.0</strong>, effective
                  9 July 2026, which forms part of these Terms.
                </p>

                <p>
                  Unless otherwise specified in the Refund Policy, convenience
                  fees, platform fees, and payment gateway charges separately
                  disclosed at checkout may be non-refundable.
                </p>

                <p>
                  Refund requests should generally be submitted through
                  <strong> Help & Support &gt; Refunds & Cancellations</strong>
                  or by contacting Fixovera customer support.
                </p>

                <hr className="section-divider" />

                <h3>7. Service Quality and Complaints</h3>

                <p>
                  Customers should report service quality issues as soon as
                  reasonably possible after completion of the service.
                </p>

                <p>
                  Where a complaint relates to service quality, Fixovera may
                  request photographs, videos, descriptions, invoices, or
                  other relevant information to assess the complaint.
                </p>

                <p>
                  Depending on the circumstances, Fixovera may offer a
                  corrective service, partial refund, full refund, or other
                  appropriate resolution in accordance with its applicable
                  policies.
                </p>

                <p>
                  Fixovera may request a site inspection or additional
                  information before making a final decision regarding a
                  service-quality complaint.
                </p>

                <hr className="section-divider" />

                <h3>8. Customer Responsibilities</h3>

                <p>
                  Customers are responsible for ensuring that the Service
                  Professional can safely access the service location and
                  perform the requested work.
                </p>

                <ul>
                  <li>
                    Provide accurate address and contact information.
                  </li>
                  <li>
                    Provide reasonable access to the premises at the confirmed
                    service time.
                  </li>
                  <li>
                    Disclose relevant information regarding the service
                    requirement.
                  </li>
                  <li>
                    Ensure that pets, children, valuables, and other property
                    are appropriately secured where necessary.
                  </li>
                  <li>
                    Do not request Service Professionals to perform unlawful
                    or unsafe activities.
                  </li>
                  <li>
                    Do not provide false, misleading, or fraudulent
                    information.
                  </li>
                </ul>

                <hr className="section-divider" />

                <h3>9. Service Professional Responsibilities</h3>

                <p>
                  Service Professionals using the Platform are expected to
                  provide services professionally, safely, lawfully, and in
                  accordance with the applicable service requirements.
                </p>

                <p>
                  Service Professionals are responsible for maintaining the
                  qualifications, licenses, registrations, tools, equipment,
                  and other requirements applicable to the services they
                  provide.
                </p>

                <p>
                  Fixovera may take appropriate action against Service
                  Professionals who violate Platform rules, customer safety
                  requirements, applicable law, or these Terms.
                </p>

                <hr className="section-divider" />

                <h3>10. Location and GPS Access</h3>

                <p>
                  Fixovera may request access to a User's location to provide
                  location-dependent features such as service-area matching,
                  nearby Service Professional discovery, navigation, estimated
                  arrival times, distance calculations, and service verification.
                </p>

                <p>
                  Location access is subject to the user's device permissions
                  and Fixovera's Privacy Policy for Mobile GPS Location Access.
                </p>

                <p>
                  Users may withdraw location permission through their device
                  settings. Certain location-dependent features may not work
                  when location permission is denied.
                </p>

                <hr className="section-divider" />

                <h3>11. Live Tracking</h3>

                <p>
                  Fixovera may provide live tracking during an active Booking
                  so that a Customer can view the approximate or real-time
                  location of the assigned Service Professional while the
                  professional is travelling to the service location.
                </p>

                <p>
                  Live tracking may include GPS location, journey milestones,
                  estimated arrival time, route information, and related
                  operational data.
                </p>

                <p>
                  Live tracking is generally limited to the active Booking
                  period and is handled in accordance with Fixovera's Privacy
                  Policy for Live Tracking Access.
                </p>

                <hr className="section-divider" />

                <h3>12. Camera and Image Access</h3>

                <p>
                  Fixovera may request camera access to allow Customers or
                  Service Professionals to capture photographs or videos
                  relating to service requirements, service completion,
                  property condition, identity verification, profiles, or
                  dispute resolution.
                </p>

                <p>
                  Fixovera does not access the camera without the User
                  initiating an applicable capture action within the App.
                  Camera and image permissions are governed by Fixovera's
                  Privacy Policy for Camera Access.
                </p>

                <hr className="section-divider" />

                <h3>13. Contact Access</h3>

                <p>
                  Certain optional features may allow Users to select contacts
                  from their device for referrals, booking sharing, or
                  designation of an alternate contact person.
                </p>

                <p>
                  Contact access is permission-based and user-initiated.
                  Customers can continue using the core booking and service
                  functionality without granting contact access.
                </p>

                <p>
                  Contact information is handled in accordance with Fixovera's
                  Privacy Policy for Contact Access.
                </p>

                <hr className="section-divider" />

                <h3>14. User Content</h3>

                <p>
                  Users may submit photographs, videos, reviews, feedback,
                  service descriptions, messages, documents, or other content
                  through the Platform ("User Content").
                </p>

                <p>
                  Users retain ownership of their User Content, subject to the
                  rights granted to Fixovera under these Terms.
                </p>

                <p>
                  By submitting User Content, the User grants Fixovera a
                  limited, non-exclusive, royalty-free right to store, process,
                  display, reproduce, and use such content as reasonably
                  necessary to provide, operate, secure, improve, and support
                  the Platform and related Services.
                </p>

                <p>
                  Users must not upload content that is unlawful, defamatory,
                  abusive, fraudulent, infringing, obscene, threatening, or
                  otherwise prohibited by applicable law.
                </p>

                <hr className="section-divider" />

                <h3>15. Prohibited Activities</h3>

                <p>
                  Users must not use the Platform to:
                </p>

                <ul>
                  <li>Commit or facilitate any unlawful activity.</li>
                  <li>
                    Provide false, misleading, fraudulent, or deceptive
                    information.
                  </li>
                  <li>
                    Impersonate another person, Service Professional, or
                    organization.
                  </li>
                  <li>
                    Attempt to gain unauthorized access to the Platform or
                    another User's account.
                  </li>
                  <li>
                    Introduce viruses, malware, malicious code, or other
                    harmful technologies.
                  </li>
                  <li>
                    Interfere with or disrupt the Platform or its underlying
                    infrastructure.
                  </li>
                  <li>
                    Scrape, copy, reproduce, or commercially exploit Platform
                    content without authorization.
                  </li>
                  <li>
                    Circumvent security, authentication, or access controls.
                  </li>
                  <li>
                    Harass, threaten, abuse, or discriminate against other
                    Users or Service Professionals.
                  </li>
                  <li>
                    Submit fraudulent refund, damage, cancellation, or service
                    quality claims.
                  </li>
                  <li>
                    Misuse promotional offers, credits, referrals, or other
                    Platform benefits.
                  </li>
                </ul>

                <hr className="section-divider" />

                <h3>16. Intellectual Property</h3>

                <p>
                  All intellectual property relating to the Fixovera Platform,
                  including its software, source code, design, interface,
                  graphics, logos, trademarks, service names, text, images,
                  content, and other materials, is owned by or licensed to
                  Fixovera Pvt Ltd unless otherwise stated.
                </p>

                <p>
                  Users may access and use the Platform only for its intended
                  purpose. No User receives any ownership interest or license
                  to reproduce, modify, distribute, sell, reverse engineer, or
                  commercially exploit Fixovera's intellectual property except
                  where expressly authorized in writing.
                </p>

                <hr className="section-divider" />

                <h3>17. Third-Party Services</h3>

                <p>
                  The Platform may integrate with third-party services,
                  including payment processors, mapping and navigation
                  providers, cloud infrastructure providers, communication
                  providers, analytics services, and other technology
                  providers.
                </p>

                <p>
                  Third-party services may be subject to their own terms and
                  privacy policies. Fixovera is not responsible for the
                  independent policies, availability, or practices of
                  third-party providers except to the extent required by
                  applicable law.
                </p>

                <hr className="section-divider" />

                <h3>18. Communications</h3>

                <p>
                  By creating an account or placing a Booking, Users may
                  receive service-related communications through SMS, phone
                  calls, email, push notifications, or in-app messages.
                </p>

                <p>
                  Such communications may include Booking confirmations,
                  appointment reminders, Service Professional information,
                  arrival notifications, payment updates, support messages,
                  security notifications, and other essential service
                  communications.
                </p>

                <p>
                  Promotional communications will be handled in accordance
                  with applicable law and the User's communication preferences.
                </p>

                <hr className="section-divider" />

                <h3>19. Safety and Emergency Situations</h3>

                <p>
                  Fixovera may provide safety-related features such as live
                  tracking, emergency assistance, trip-sharing, or support
                  communication where available.
                </p>

                <p>
                  These features are intended to support safety but do not
                  guarantee prevention of accidents, crime, injury, property
                  damage, or other harmful events.
                </p>

                <p>
                  Users should contact appropriate emergency services directly
                  whenever immediate emergency assistance is required.
                </p>

                <hr className="section-divider" />

                <h3>20. Service Availability and Modifications</h3>

                <p>
                  Fixovera may modify, suspend, restrict, or discontinue any
                  portion of the Platform or Services at any time, including
                  for maintenance, security, technical improvements,
                  operational requirements, or other legitimate business
                  reasons.
                </p>

                <p>
                  Fixovera does not guarantee that the Platform or any
                  particular Service will always be available, uninterrupted,
                  error-free, or compatible with every device or network.
                </p>

                <hr className="section-divider" />

                <h3>21. Disclaimer of Warranties</h3>

                <p>
                  To the maximum extent permitted by applicable law, the
                  Platform and related Services are provided on an "as is" and
                  "as available" basis.
                </p>

                <p>
                  Fixovera does not guarantee that a Service Professional will
                  always be available, that a Booking will always be accepted,
                  or that Services will meet every Customer expectation.
                </p>

                <p>
                  Fixovera does not provide warranties regarding uninterrupted
                  availability, accuracy, completeness, suitability, or
                  fitness for a particular purpose except where such warranties
                  cannot legally be excluded.
                </p>

                <hr className="section-divider" />

                <h3>22. Limitation of Liability</h3>

                <p>
                  To the maximum extent permitted by applicable law, Fixovera
                  Pvt Ltd and its directors, officers, employees, affiliates,
                  agents, and technology partners shall not be liable for
                  indirect, incidental, special, consequential, or punitive
                  damages arising from the use of or inability to use the
                  Platform or Services.
                </p>

                <p>
                  Nothing in these Terms excludes or limits liability that
                  cannot legally be excluded or limited under applicable law.
                </p>

                <hr className="section-divider" />

                <h3>23. Indemnification</h3>

                <p>
                  Users agree to indemnify and hold harmless Fixovera Pvt Ltd,
                  its directors, officers, employees, affiliates, agents, and
                  service partners from claims, losses, liabilities, damages,
                  costs, and expenses arising from:
                </p>

                <ul>
                  <li>
                    The User's violation of these Terms or applicable law.
                  </li>
                  <li>
                    Fraudulent, negligent, or unlawful use of the Platform.
                  </li>
                  <li>
                    User Content submitted through the Platform.
                  </li>
                  <li>
                    Violation of another person's rights.
                  </li>
                  <li>
                    Misuse of Services, bookings, refunds, promotions, or
                    Platform features.
                  </li>
                </ul>

                <hr className="section-divider" />

                <h3>24. Suspension and Termination</h3>

                <p>
                  Fixovera may suspend, restrict, or terminate a User's access
                  to the Platform where the User violates these Terms, engages
                  in fraud or abuse, creates a safety risk, fails to make
                  required payments, or otherwise misuses the Platform.
                </p>

                <p>
                  Fixovera may also take such action where required to comply
                  with applicable law or instructions from a competent
                  governmental or regulatory authority.
                </p>

                <p>
                  Termination or suspension does not affect rights or
                  obligations that accrued before the effective date of such
                  suspension or termination.
                </p>

                <hr className="section-divider" />

                <h3>25. Refunds, Cancellations and Disputes</h3>

                <p>
                  Refunds and cancellations are governed by Fixovera's
                  <strong> Refund Policy — Version 2.0</strong>, effective
                  9 July 2026.
                </p>

                <p>
                  Customers should raise refund or cancellation requests
                  through:
                </p>

                <ul>
                  <li>
                    <strong>In-App:</strong> Help & Support &gt; Refunds &
                    Cancellations
                  </li>
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:support@fixovera.com">
                      support@fixovera.com
                    </a>
                  </li>
                  <li>
                    <strong>Phone:</strong> +91 62904 25024
                  </li>
                </ul>

                <p>
                  Where a Customer disagrees with a refund decision, an
                  escalation may be requested through the Platform's support
                  section within the applicable period specified in the Refund
                  Policy.
                </p>

                <hr className="section-divider" />

                <h3>26. Fraud, Abuse and Policy Misuse</h3>

                <p>
                  Fixovera may deny a request, suspend an account, restrict
                  Platform access, or take other appropriate action where it
                  reasonably determines that a User has engaged in fraudulent,
                  abusive, or bad-faith conduct.
                </p>

                <p>This may include:</p>

                <ul>
                  <li>Repeated last-minute cancellations.</li>
                  <li>False service quality or damage claims.</li>
                  <li>Fraudulent refund requests.</li>
                  <li>Misuse of promotional credits.</li>
                  <li>Manipulation of referrals or Platform incentives.</li>
                  <li>Any other misuse of the Platform or its policies.</li>
                </ul>

                <hr className="section-divider" />

                <h3>27. Privacy and Permission-Based Access</h3>

                <p>
                  Use of the Platform may require or offer optional access to
                  device permissions including location, camera, live tracking,
                  and contacts.
                </p>

                <p>
                  Such permissions are handled in accordance with Fixovera's
                  applicable permission-specific Privacy Policies and general
                  Privacy Policy.
                </p>

                <p>
                  Users may manage device permissions through their device
                  settings. Certain Platform features may not function when
                  the relevant permission is denied.
                </p>

                <hr className="section-divider" />

                <h3>28. Changes to These Terms</h3>

                <p>
                  Fixovera may update these Terms from time to time to reflect
                  changes in its Services, technology, legal requirements,
                  business practices, or Platform features.
                </p>

                <p>
                  Updated Terms will be made available through the Platform.
                  Where required by applicable law, Fixovera will provide
                  additional notice of material changes.
                </p>

                <p>
                  Continued use of the Platform after the updated Terms become
                  effective constitutes acceptance of the revised Terms,
                  subject to applicable law.
                </p>

                <hr className="section-divider" />

                <h3>29. Governing Law and Jurisdiction</h3>

                <p>
                  These Terms shall be governed by and interpreted in
                  accordance with the laws of India.
                </p>

                <p>
                  Subject to applicable law, disputes arising out of or in
                  connection with these Terms or the Platform shall be subject
                  to the jurisdiction of the competent courts having
                  jurisdiction over Fixovera Pvt Ltd's registered office.
                </p>

                <hr className="section-divider" />

                <h3>30. General Provisions</h3>

                <p>
                  <strong>Entire Agreement:</strong> These Terms, together
                  with the Privacy Policy, Refund Policy, and other policies
                  expressly incorporated into the Platform, constitute the
                  agreement between Fixovera and the User regarding use of the
                  Platform.
                </p>

                <p>
                  <strong>Severability:</strong> If any provision of these
                  Terms is found to be invalid or unenforceable, the remaining
                  provisions will continue in full force and effect to the
                  extent permitted by law.
                </p>

                <p>
                  <strong>Waiver:</strong> Failure by Fixovera to enforce any
                  provision of these Terms shall not constitute a waiver of
                  that provision or any other right.
                </p>

                <p>
                  <strong>Assignment:</strong> Fixovera may assign or transfer
                  its rights and obligations under these Terms in connection
                  with a merger, acquisition, restructuring, sale of assets,
                  or other lawful business transaction. Users may not transfer
                  their account or obligations without Fixovera's prior written
                  consent where such consent is required.
                </p>

                <p>
                  <strong>Relationship:</strong> Use of the Platform does not
                  create an employment, agency, partnership, joint venture, or
                  franchise relationship between a Customer and Fixovera,
                  except where expressly stated otherwise.
                </p>

                <hr className="section-divider" />

                <h3>31. Customer Support and Contact Information</h3>

                <p>
                  For questions, complaints, service-related concerns,
                  cancellation requests, or other support matters, Users may
                  contact Fixovera through:
                </p>

                <ul>
                  <li>
                    <strong>In-App:</strong> Settings &gt; Help & Support
                  </li>
                  <li>
                    <strong>Refunds:</strong> Help & Support &gt; Refunds &
                    Cancellations
                  </li>
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:support@fixovera.com">
                      support@fixovera.com
                    </a>
                  </li>
                  <li>
                    <strong>Phone:</strong> +91 62904 25024
                  </li>
                </ul>

                <p>
                  <strong>Registered Office:</strong>
                  <br />
                  Fixovera Pvt Ltd
                  <br />
                  392, Ranikuthir
                  <br />
                  Apurbapur
                  <br />
                  Singur
                  <br />
                  WB-712409
                </p>

                <p className="mt-4">
                  By accessing or using the Fixovera Platform, you confirm that
                  you have read, understood, and agreed to these Terms &
                  Conditions.
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Global Newsletter Section */}
      <Newsletter />

      {/* Global Footer Component */}
      <Footer />
    </div>
  );
}

export default TermsAndConditions;